import { type NetworkType } from "../models/app-config";
import accountRequest from "../utils/axios/accountRequest";

export enum Networks {
  ETHEREUM,
  BSC,
  POLYGON,
}
export interface Token {
  id: string;
  account_id: number;
  price_in_fiat: number;
  balance: string;
  network: Networks;
  chain_id: number;
  network_type: string;
  graph_url: string;
  contract_address: string;
  name: string;
  is_coin: boolean;
  decimals: number;
  network_id: number;
  symbol: number;
  image: {
    thumb?: string;
    small?: string;
    large?: string;
  };
  rate: number;
  asset_platform_id: number;
}

export interface TopNetworksAndTokensType {
  netWorth: string;
  topTokens: Token[];
  topNetworks: NetworkType[];
}

export interface AccountBalance {
  asset_value_usd: {
    bsc: number;
    polygon: number;
    ethereum: number;
  };
  tokens: Token[];
}

export const accountBalanceApi = {
  getBalance: async (walletAddress: string): Promise<AccountBalance> => {
    return await accountRequest.get(`/${walletAddress}`);
  },
};
